import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body } from 'syf-component-library/ui/typography';
import { NoMembersFoundContainer } from './subcomponents';
import { translate } from '../../../strings/i18n';
import SamsSteps from '../SamsSteps';
const NoEligibleMembersFound = () => (_jsxs(NoMembersFoundContainer, { top: "xlarge", bottom: "medium", vertical: "medium", children: [_jsx(Body, { weight: "bold", children: translate('noEligibleMembersFound') }), _jsx(SamsSteps, { title: translate('steps.title') })] }));
export default NoEligibleMembersFound;
